import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from 'lodash';
import Sticky from 'react-stickynode';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Breadcrumb } from "../../../breadcrumb/src";
import { TabsList } from "../../../tabs-list/src";
import { primaryShadow, useTheme, zIndices } from "../../../theme/src";
import { MainActionType } from './MainActionType';
import { TitleBlock } from './TitleBlock';
import { usePageHeaderContext } from '../context/PageHeaderContext';
export const Content = () => {
    const theme = useTheme();
    const { breadcrumbItems, mainAction, tabs, title, translationActions } = usePageHeaderContext();
    return (_jsx(StickyWrapper, { innerZ: zIndices.sticky, children: _jsxs(PageHeaderContainer, { "$theme": theme, "$withTabs": tabs, children: [_jsxs(Box, { justifyContent: "space-between", children: [_jsxs(Box, { alignSelf: "center", flexDirection: "column", pr: 4, children: [!isEmpty(breadcrumbItems) && (_jsx(Box, { mb: 5, children: _jsx(Breadcrumb, { breadcrumbItems: breadcrumbItems, tailing: true }) })), _jsx(TitleBlock, { title: title, translationActions: translationActions })] }), (mainAction === null || mainAction === void 0 ? void 0 : mainAction.type) && (_jsx(Box, { alignItems: "flex-start", flexShrink: 0, children: _jsx(MainActionType, {}) }))] }), !isEmpty(tabs) && _jsx(TabsList, { tabs: tabs })] }) }));
};
const PageHeaderContainer = styled(Box).attrs(({ $theme, $withTabs }) => ({
    backgroundColor: $theme.colors.white,
    display: 'block',
    height: 'fit-content',
    p: $withTabs ? '24px 32px 16px 32px' : '24px 32px 24px 32px',
    width: '100%',
})) `
  ${primaryShadow}
`;
const StickyWrapper = styled(Sticky) `
  width: inherit;
`;
//# sourceMappingURL=Content.js.map